import { EmptyProps } from "antd/es/empty";
import AntdEmpty from "antd/es/empty";
export type { EmptyProps } from "antd/es/empty";

export const Empty: React.FC<EmptyProps> = AntdEmpty;
